import { useTranslation } from "react-i18next";
import {
  BorderGreyBox,
  BoxSpg,
  CardSpg,
  EnabledFilter,
  handleSubmitValidationFail,
  NameFilter,
  useReactHookForm,
} from "@duosoftbg/nacid-components";
import { SEARCH_FILTERS_GROUP } from "../../../../config/search/filters/groupsConfig";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import { RolesFilter } from "../../../../types/groupsAndRolesTypes";
import { createUsersFilterValidationSchema } from "../../../../yup/schema/users/usersFilterValidationSchema";
import useSearchTableControl from "../../../../hooks/portal/search/useSearchTableControl";
import { searchUsers } from "../../../../axios/api/services";
import { usersFilterInitialValues } from "../../../../init/usersFilterInitialValues";
import SearchFilters from "../../common/search/filters/SearchFilters";
import React from "react";
import { FormProvider } from "react-hook-form";
import UsersList from "./UsersList";
import UsernameFilter from "../../common/search/filters/definition/UsernameFilter";
import EmailFilter from "../../common/search/filters/definition/EmailFilter";
import EmailVerifiedFilter from "../../common/search/filters/definition/EmailVerifiedFilter";
import { CardContent, Grid } from "@mui/material";

const UsersFilters = () => {
  return (
    <Grid container spacing={5} px={2} py={6}>
      <NameFilter />
      <UsernameFilter />
      <EmailFilter />
      <EnabledFilter />
      <EmailVerifiedFilter />
    </Grid>
  );
};
const MemoizedFilters = React.memo(UsersFilters);

const Users = () => {
  const { t } = useTranslation();
  const group = SEARCH_FILTERS_GROUP.USERS;

  const filtersData = useAppSelector((state) => {
    return state.SearchData.portalSearchTable[group].filtersData;
  });

  const { methods } = useReactHookForm<RolesFilter>({
    defaultValues: filtersData,
    validationSchema: createUsersFilterValidationSchema,
  });

  const control = useSearchTableControl({
    group,
    methods,
    initialValues: usersFilterInitialValues,
    filterData: searchUsers,
    callAfterResetFilters: true,
  });

  return (
    <>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(
            () => control.handleSubmitFilters(),
            () => handleSubmitValidationFail(methods.formState, t),
          )}
        >
          <CardSpg my={4} style={{ overflow: "visible" }}>
            <CardContent style={{ position: "relative" }}>
              <BoxSpg>
                <BorderGreyBox>
                  <SearchFilters
                    isSubmitBtnDisabled={control.isSubmitBtnDisabled}
                    isResetBtnDisabled={control.isResetBtnDisabled}
                    handleResetFilters={control.handleResetFilters}
                  >
                    <MemoizedFilters />
                  </SearchFilters>
                </BorderGreyBox>
                {control.showList && (
                  <UsersList
                    records={control.records}
                    total={control.total}
                    isLoading={control.isLoading}
                    onPageOrOrderChange={control.handlePageOrOrderChange}
                    blockTable={control.blockTable}
                    group={group}
                  />
                )}
              </BoxSpg>
            </CardContent>
          </CardSpg>
        </form>
      </FormProvider>
    </>
  );
};

export default Users;
